"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TablePaginationModel_1 = require("./TablePaginationModel");
const SortModel_1 = require("./SortModel");
const TableFilterModel_1 = require("./TableFilterModel");
class TableCollection {
    constructor(baseCollection, pagination, filter, sort) {
        this.data = [];
        this.meta = {};
        this.pagination = new TablePaginationModel_1.TablePaginationModel();
        this.filter = null;
        this.sort = null;
        this.data = baseCollection.data;
        this.meta = baseCollection.meta;
        if (pagination) {
            this.pagination = pagination;
        }
        if (filter) {
            this.filter = filter;
        }
        else {
            this.filter = new TableFilterModel_1.TableFilterModel('');
        }
        if (sort) {
            this.sort = sort;
        }
        else {
            this.sort = new SortModel_1.SortModel();
        }
    }
    get isEmpty() {
        return this.data.length === 0;
    }
    get hasPagination() {
        return this.pagination !== null;
    }
    get hasFilter() {
        return this.filter !== null;
    }
    get hasSort() {
        return this.sort !== null;
    }
}
exports.TableCollection = TableCollection;
//# sourceMappingURL=TableCollection.js.map